import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import isNil from 'lodash/isNil';
import { useState } from 'react';
import { useAsyncFn } from 'react-use/lib';
import { Fields, getKeywordValueFromOptionId, getSiteConfigByContentType, getTextToProcess } from '@uno/common-cms';
import { getScore } from 'services/networking/semantic-score';
export var useFetchScore = function useFetchScore() {
  var defaultScore = {
    score: 0,
    danger: 0,
    optimizationLevels: {}
  };

  var _useState = useState(defaultScore),
      _useState$ = _useState[0],
      score = _useState$.score,
      danger = _useState$.danger,
      optimizationLevels = _useState$.optimizationLevels,
      setYTGScore = _useState[1];

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(content, formField) {
      var contentData, text, semanticScoreField, keyword, lang, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              contentData = content.contentData;
              text = getTextToProcess(content, formField.textPropertiesPath);
              semanticScoreField = isNil(contentData[Fields.SEMANTIC_SCORE]) ? '' : contentData[Fields.SEMANTIC_SCORE][0];
              keyword = semanticScoreField !== undefined && semanticScoreField !== '' ? getKeywordValueFromOptionId(semanticScoreField) : '';

              if (!(keyword === '' || text === '')) {
                _context.next = 7;
                break;
              }

              setYTGScore(defaultScore);
              return _context.abrupt("return");

            case 7:
              lang = getSiteConfigByContentType(content.contentType).lang;
              _context.next = 10;
              return getScore({
                entityId: content.id,
                lang: lang,
                keyword: keyword,
                text: text
              });

            case 10:
              result = _context.sent;
              setYTGScore(result);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }()),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      _useAsyncFn2$ = _useAsyncFn2[0],
      loading = _useAsyncFn2$.loading,
      error = _useAsyncFn2$.error,
      doFetchScore = _useAsyncFn2[1];

  return {
    loading: loading,
    doFetchScore: doFetchScore,
    error: error,
    score: score,
    danger: danger,
    optimizationLevels: optimizationLevels
  };
};
export default useFetchScore;